import { Trans } from '@/plugins/Translation'
import { i18n } from '@/plugins/i18n'


function load (component) {
  // '@' is aliased to src/components
  return () => import(/* webpackChunkName: "[request]" */ `@/pages/${component}.vue`)
}

export default [
  {
    path: '/:lang',
    component: {
      template: '<router-view></router-view>'
    },
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: '',
        name: 'splashPage',
        component: load('splashPage'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Accueil',
            path: '/'
          },
          en: {
            title: 'Encounters with Canada - Homepage',
            path: '/'
          }
        }
      },
      /* Quiz Introduction */
      {
        path: 'introduction-fake-new-01',
        alias: 'introduction-fausses-nouvelles-01',
        name: 'Quiz_info01',
        component: load('Quiz_info01'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Introduction',
            path: 'introduction-fausses-nouvelles-01'
          },
          en: {
            title: 'Encounters with Canada - Introduction'
          }
        }
      },
      {
        path: 'introduction-fake-new-02',
        alias: 'introduction-fausses-nouvelles-02',
        name: 'Quiz_info02',
        component: load('Quiz_info02'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Introduction',
            path: 'introduction-fausses-nouvelles-02'
          },
          en: {
            title: 'Encounters with Canada - Introduction'
          }
        }
      },
      {
        path: 'introduction-fake-new-03',
        alias: 'introduction-fausses-nouvelles-03',
        name: 'Quiz_info03',
        component: load('Quiz_info03'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Introduction',
            path: 'introduction-fausses-nouvelles-03'
          },
          en: {
            title: 'Encounters with Canada - Introduction'
          }
        }
      },
      {
        path: 'introduction-fake-new-04',
        alias: 'introduction-fausses-nouvelles-04',
        name: 'Quiz_info04',
        component: load('Quiz_info04'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Introduction',
            path: 'introduction-fausses-nouvelles-04'
          },
          en: {
            title: 'Encounters with Canada - Introduction'
          }
        }
      },
      /* CHAPTER 1 */
      {
        path: 'understand-the-system',
        alias: 'comprendre-le-systeme',
        name: 'Chapter01',
        component: load('Chapter01'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Comprendre le système',
            path: 'comprendre-le-systeme'
          },
          en: {
            title: 'Encounters with Canada - Understand The System'
          }
        }
      },
      /* CHAPTER 2 */
      {
        path: 'assess-channels-and-bias',
        alias: 'evaluer-les-canaux-et-le-bias',
        name: 'Chapter02',
        component: load('Chapter02'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Evaluer les canaux et le bias',
            path: 'evaluer-les-canaux-et-le-bias'
          },
          en: {
            title: 'Encounters with Canada - Assess Channels And Bias'
          }
        }
      },
      /* CHAPTER 3 */
      {
        path: 'examine-the-source-and-content',
        alias: 'examiner-la-source-et-le-contenu',
        name: 'Chapter03',
        component: load('Chapter03'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Examiner la source et le contenu',
            path: 'examiner-la-source-et-le-contenu'
          },
          en: {
            title: 'Encounters with Canada - Examine The Source And Content'
          }
        }
      },
      /* CHAPTER 4 */
      {
        path: 'check-the-facts',
        alias: 'verifier-les-faits',
        name: 'Chapter04',
        component: load('Chapter04'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Vérifier les faits',
            path: 'verifier-les-faits'
          },
          en: {
            title: 'Encounters with Canada - Check The Facts'
          }
        }
      },
      /* CONCLUSION */
      {
        path: 'conclusion',
        alias: 'conclusion',
        name: 'conclusionScreen',
        component: load('conclusionScreen'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Conclusion',
            path: 'conclusion'
          },
          en: {
            title: 'Encounters with Canada - Conclusion'
          }
        }
      },
      /* FINAL SCORES */
      {
        path: 'your-scores',
        alias: 'vos-scores',
        name: 'resumeScreen',
        component: load('resumeScreen'),
        meta: {
          fr: {
            title: 'Rencontre du Canada - Vos Scores',
            path: 'vos-scores'
          },
          en: {
            title: 'Encounters with Canada - Yours Scores'
          }
        }
      },
      {
        path: '*',
        component: load('404')
      }
    ]
  },
  {
    // Redirect user to supported lang version.
    path: '*',
    redirect (to) {
      return Trans.getUserSupportedLang()
    }
  }
]






// WEBPACK FOOTER //
// ./src/router/routes.js